import {MenuPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-menu-options/poster-editing-menu-options.types';
import {useEffect} from 'react';
import {LayoutBackgroundTypes} from '@PosterWhiteboard/items/layouts/layout.types';
import {BorderType} from '@PosterWhiteboard/classes/item-border.class';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';

export function useIsOpenedMenuPanelValid(currentlyOpenedPanel: MenuPanels, setCurrentlyOpenedPanel: (newVal: MenuPanels) => void): void {
  const backgroundType = useGetKeyFromTableItem('backgroundType');
  const solidBorderType = useGetKeyFromBorderOfActiveItem('solidBorderType');
  const stroke = useGetKeyFromTextStylesActiveItem('stroke');

  useEffect((): void => {
    if (backgroundType === LayoutBackgroundTypes.NONE && currentlyOpenedPanel === MenuPanels.BACKGROUND) {
      setCurrentlyOpenedPanel(MenuPanels.NONE);
    }
  }, [backgroundType]);

  useEffect((): void => {
    if (solidBorderType === BorderType.NONE && currentlyOpenedPanel === MenuPanels.BORDER) {
      setCurrentlyOpenedPanel(MenuPanels.NONE);
    }
  }, [solidBorderType]);

  useEffect((): void => {
    if (!stroke && currentlyOpenedPanel === MenuPanels.OUTLINE) {
      setCurrentlyOpenedPanel(MenuPanels.NONE);
    }
  }, [stroke]);

  return;
}
